import { IPartnerProductSearchResult } from "@iloq/shared/IProduct";
import { IActiveProductSearchQuery } from "@iloq/shared/IProductSearchQuery";
import { infiniteQueryOptions, queryOptions } from "@tanstack/react-query";
import { AxiosInstance } from "axios";

export const SEARCH_ACTIVE_PARTNER_PRODUCTS_QUERY_KEY =
  "searchActivePartnerProducts";

export async function searchActivePartnerProducts({
  query,
  axiosInstance,
}: {
  query: IActiveProductSearchQuery;
  axiosInstance: AxiosInstance;
}): Promise<IPartnerProductSearchResult> {
  const response = await axiosInstance.post<IPartnerProductSearchResult>(
    "/api/v1/products/product/search-active",
    query,
  );
  return response.data;
}

export function getSearchActivePartnerProductsQueryOptions({
  query,
  axiosInstance,
}: {
  query: IActiveProductSearchQuery;
  axiosInstance: AxiosInstance;
}) {
  return queryOptions({
    queryKey: [SEARCH_ACTIVE_PARTNER_PRODUCTS_QUERY_KEY, query] as const,
    queryFn: () => searchActivePartnerProducts({ query, axiosInstance }),
  });
}

export function getSearchActivePartnerProductsInfiniteQueryOptions({
  query,
  axiosInstance,
  pageSize,
}: {
  query: Omit<IActiveProductSearchQuery, "skip" | "top">;
  axiosInstance: AxiosInstance;
  pageSize: number;
}) {
  return infiniteQueryOptions({
    queryKey: [
      SEARCH_ACTIVE_PARTNER_PRODUCTS_QUERY_KEY,
      "infinite",
      query,
      pageSize,
    ] as const,
    queryFn: ({ pageParam }) =>
      searchActivePartnerProducts({
        axiosInstance,
        query: {
          ...query,
          top: pageSize,
          skip: pageParam,
        },
      }),
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      const loaded = allPages.flatMap((page) => page.value).length;
      return loaded < lastPage.count ? loaded : undefined;
    },
  });
}
